import React, { useEffect, useState } from 'react'
import {
  Create,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  useCreateContext,
  useNotify,
  useRedirect,
  useTranslate
} from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { Grid } from '@mui/material'
import { NumberInput } from 'src/components/uiElements/fields/NumberInput'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'
import { dueDateServices } from 'src/services/reservation/due-date/dueDate.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'



export const DueDateMethodCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const { isLoading } = useCreateContext();
  const redirect = useRedirect()
  const [loadingDueDateRange, setLoadingDueDateRange] = useState(false)
  const [dueDateRange, setDueDateRange] = useState([])
  const typeDeterminationOptions = [
    {id:'autocancel_date', label:translate('ra.field.autocancel_date')},
    {id:'date_in', label:translate('ra.field.date_origin_service')}
  ]

  const getDueDateRange = async (name, minLength = 1) => {
    if (name?.length < minLength) {
      return
    }
    try {
      setLoadingDueDateRange(true)
      const dueDateRange = await dueDateServices.getByAllDueDateRange({ name__ilike: name })
      setDueDateRange(dueDateRange)
    } catch (error) {
      setDueDateRange([])
    } finally {
      setLoadingDueDateRange(false)
    }
  }
 
  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.due-date-method') }
    })
    redirect('/due-date-method')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.due-date-method') }
    })
  }

  const transform = (data) => {
    let obj = {
      ...data,
      due_date_range_id: data?.due_date_range_id?.id,
    }

    return obj
  }

  const CardCrudBottomButtons = ({ btnSave }) => (
    <Toolbar>
      {(btnSave && !isLoading) && <SaveButton />}
    </Toolbar>
  );

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null} transform={transform}>
      <CardCommon title={translate('ra.title.create_due_date_method')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.days')}>
              <NumberInput source='days' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.due-date-range')}>
              <AutocompleteInput
                source='due_date_range_id'
                options={dueDateRange}
                loading={loadingDueDateRange}
                optionsText={['name']}
                onSearch={getDueDateRange}
                resetOnLoad={false}
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.type_determination_date')}>
              <SelectInput
                size='small'
                optionsText={['label']}
                source='type_determination_date'
                options={typeDeterminationOptions}
                fullWidth
                label=''
                validate={[required()]}
              />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}